export const MODAL_TYPES = {
  NEW_USER: 'NEW_USER',
  SPACE_FORM: 'SPACE_FORM', // For add/edit space
  FLOOR_FORM: 'FLOOR_FORM', // For adding/editing floors
  BOQ_FORM: 'BOQ_FORM', // For adding/editing BOQ items
  WINDOW_FORM: 'WINDOW_FORM', // For adding/editing windows in a space
  DOCUMENTS_MODAL: 'DOCUMENTS_MODAL', // For viewing and managing documents
  VENDOR_FORM: 'VENDOR_FORM', // For adding/editing vendors for project items
  PAYMENT_FORM: 'PAYMENT_FORM', // For adding payments to financial items
  BOQ_TEMPLATE_SELECTION: 'BOQ_TEMPLATE_SELECTION', // For selecting and drafting BOQ template items
  QUOTE_FORM: 'QUOTE_FORM', // For creating/editing vendor quotes
  QUOTE_COMPARISON: 'QUOTE_COMPARISON', // For comparing quotes side-by-side
  FLOOR_PLAN_ANALYSIS: 'FLOOR_PLAN_ANALYSIS', // For analyzing floor plans with AI
  IMPORT_BOQ_NOTES: 'IMPORT_BOQ_NOTES', // For importing system/architect BOQ notes into a project
  TRADE_QUOTES: 'TRADE_QUOTES', // For managing competing quotes for a trade in NeedsQuotesTab
};
